import React, { useState, useEffect } from "react"
import ReactDOM from "react-dom"
import "./frontend.min.css"

document.addEventListener("DOMContentLoaded", function () {
    const divsToUpdate = document.querySelectorAll(".accordion-update-me")

    divsToUpdate.forEach(function (div) {
        const data = JSON.parse(div.querySelector("pre").innerHTML)
        const content = {accordionContent: div.querySelector("span").innerHTML}
        Object.assign(data, content)
        // data.push({accordionContent: content})

        ReactDOM.render(<Accordion {...data} />, div)
        div.classList.remove("accordion-update-me")
    })

    function Accordion(props) {
        
        const [accStatus, setAccStatus] = useState("invisible")
        const changeTab = () => {
            if ( accStatus == "invisible") {
                setAccStatus("visible")
            }
            else {
                setAccStatus("invisible")
            }
        }

        return (
            <>
                <div className={"accordion-frontend accordion " + accStatus}>
                    <div className="accordionHead" onClick={changeTab}>
                        <h2 >{props.accordionTitle}</h2>
                        <div className="opener">
<svg id="a" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" width="10" height="5.82" viewBox="0 0 10 5.82">
  <path d="M5.33,.14l4.53,4.6c.18,.18,.18,.48,0,.66l-.28,.28c-.18,.18-.48,.18-.66,0L5,1.68,1.08,5.68c-.18,.18-.48,.18-.66,0l-.28-.28c-.18-.18-.18-.48,0-.66L4.67,.13c.18-.18,.48-.18,.66,0h0Z"/>
</svg>               
                        </div>
                    </div>
                    <div className="accordionContent" dangerouslySetInnerHTML={{__html: props.accordionContent}}></div>
                </div>
            </>
        )
    }
})